import { ListItemLink } from './ListItemLink';
import useLayout from '../../../../../stores/useLayout';

export function MobileWordpressMenu() {
    const menu = useLayout((state) => state.menu);

    return (
        <nav>
            {menu?.map((item, index) => (
                <ListItemLink
                    isProductCategories={index === 0}
                    slug={item.slug}
                    title={item.title}
                    items={item.items}
                    key={index}
                />
            ))}
        </nav>
    );
}
